import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Button from "../../AdminModule/Dashboard/AdminDashboard/Button";
import "./styles.scss";
import { makeStyles } from "@material-ui/core/styles";
import {postEngagementNotes} from "../../AdminModule/Dashboard/StartupDashboard/dependencies/action";
import TextareaField from "../TextAreaField";
import swal from "sweetalert";
const useStyles = makeStyles((theme) => ({
  input: {
    backgroundColor: "white",
    padding: "0.5px 10px",
  },
}));
function EngagementNotesModal(props) {
  const {postEngagementNotes,engagementData,cohortAdminId}=props;
  let currentUserId= JSON.parse(localStorage.getItem("SavedLoggedInData")).id;
    const [fileData, setFileData] = useState();
    const classes = useStyles();
    const [wordCounter, setWordCounter] = useState(0);
    const [errorMessagePurpose, setErrorMessagePurpose] = useState(
      "*Please Enter the Summary"
    );
    const [discussonSummary, setDiscussonSummary] = useState("");

    const [errorVisible, SetErrorVisible] = useState(false);
    const [errorVisible7, SetErrorVisible7] = useState(false);
  const handleClose = () => {
    props.setModalVisibility(false);
  };
  const removeFile = (fileType) => {
    if (fileType === "uploadResume") {
      setFileData((user) => {
        return { ...user, ["uploadResume"]: null };
      });
    }
  };
  const handleSubmit =()=>{
    if(discussonSummary !== "")
    {
      SetErrorVisible7(false);
     
    const formData = new FormData();
    let params={
      mentorshipId :props.mentorshipId,  
      engagementSummary : discussonSummary,
      // supportingFile : "abc",
      userId:JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
    }
    formData.append("application", JSON.stringify(params));
    formData.append("supportingFile", fileData?.uploadResume);
    postEngagementNotes(formData);
    setTimeout(() => {
      swal({
        title: "Thank You",
        text: `Engagement Notes Submitted Successfully`,
        icon: "success",
        // timer: 1500,
        // buttons: false,
      }).then(function () {
        // props.sendToParent(true);
        props.setModalVisibility(false);
        props.engagementParentData(true);

      });
    }, 500);
          setFileData((user) => {
            return { ...user, ["uploadResume"]: null };
          });
  }
  else{
    SetErrorVisible7(true);
  }
}
  
  const handleInputChange = (e) => {
    if (e.target.files[0].type == "application/pdf") {
      setFileData((user) => {
        return { ...user, [e.target.name]: e.target.files[0] };
      });
      const newFormData = {
        ...fileData,
        [e.target.name]: e.target.files[0],
      };
      // setAppliedFormData(newFormData);
      // addDraftData(newFormData, "nextdraftbutton");
    }
  };  
  const clickonFileinput = (event) => {
    event.preventDefault();
    let element = document.getElementById("fileUpload-resume");
    element.click();
  };
  const testWordLimit = (data) => {
    let value =
      data?.length === 0
        ? 0
        : data
            ?.replace(/(^\s*)|(\s*$)/gi, "")
            ?.replace(/[ ]{2,}/gi, " ")
            ?.split(" ")?.length;
    if (value == 250) {
      setErrorMessagePurpose("Exceeds word limit reached");
      SetErrorVisible7(true);
    } else if (value < 250 && value > 0) {
      SetErrorVisible7(false);
      setErrorMessagePurpose("*Please Enter the purpose");
    } else if (value == 0) {
      SetErrorVisible7(true);
    } else if (value == 251) {
      setWordCounter(250);
      return value;
    }
    setWordCounter(value);
    return value;
  };
  return (
    <>
      <div className="modal-dialog modal-dialog-centered">
        <Modal
          size="lg"
          show={props.modalVisibility}
          onHide={() => props.setModalVisibility(false)}
          aria-labelledby="example-modal-sizes-title-lg"
          style={{ borderRadius: "7px" }}
        >
          <Modal.Header className="d-flex ">
            <Modal.Title className="modalHeading">ENGAGEMENT NOTES</Modal.Title>
            <div className="newuserTooltip">
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={handleClose}
            />
            <span className="tooltiptext  close-window" style={{left:"-130px",top:"2px",width:"130px"}}>Close Window</span>
            </div>
          </Modal.Header>
          <Modal.Body className="modalBodyFix">
            <div className="cellphonemb">
              <div className="row inputFieldPadding">
                <div className="col-4 d-flex wdthfordemo">
                  <div className="col-1 iconDiv">
                    <div>1</div>
                  </div>
                  <div className="modalHeadings">ENGAGEMENT SUMMARY*</div>
                </div>

                <div className="col-8 wdthfordemo uplodinddocumentButton2">
                <TextareaField
                      id="purpose"
                      variant="outlined"
                      placeholder="Describe in maximum 250 words"
                    
                      fullWidth
                      margin="normal"
                      style={{ backgroundColor: "white" }}
                      name="purpose"
                      rows={5}
                      InputProps={{ className: classes.input }}
                      // className="purposeBox"
                      // maxRows={4}
                      value={discussonSummary}
                      onChange={(e) => {
                        if (testWordLimit(e.target.value) < 251) {
                          setDiscussonSummary(e.target.value);
                        }
                      }}
                    />
                    <div className="wordCounter">
                      Word Count: {wordCounter} / 250
                    </div>

                    {errorVisible7 && (
                      <div className="login-error-msg mt-2">
                        {errorMessagePurpose}
                      </div>
                    )}
                </div>
              </div>
              <div className="row inputFieldPadding secondHeading">
                <div className="col-4 d-flex wdthfordemo">
                  <div className="iconDiv">
                    <div>2</div>
                  </div>
                  <div className="modalHeadings">UPLOAD DOCUMENT</div>
                </div>
                <div className="col-8 wdthfordemo">
                  <div className="newuserTooltip top-btn uplodinddocumentButton">
                  <button onClick={clickonFileinput} className="newUploadBtn">
                    CLICK TO UPLOAD
                  </button>
                  <span className="tooltiptext   tooltip-bottom" style={{top:"47px",left:"89px",width:"auto"}}>
                    Upload Document
                  </span>
                  </div>
                  <div className="uploadDocumentModal">
                    <input
                      className="uploadDocumentInput"
                      type="file"
                      id="fileUpload-resume"
                      required
                      name="uploadResume"
                      onChange={handleInputChange}
                      accept="application/pdf"
                      style={{ display: "none" }}
                    />
                  </div>
                  {fileData && fileData?.uploadResume !== null && (
                    <div style={{ marginBottom: "50px" }}>
                      <div className="file-name" style={{ float: "left" }}>
                        {fileData?.uploadResume?.name}{" "}
                        <span
                          style={{ marginLeft: "10px" }}
                          onClick={() => removeFile("uploadResume")}
                        >
                          {" "}
                          X{" "}
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="d-flex justify-content-center">
            {
              cohortAdminId == currentUserId ? (
                <div>
                <Button
                  onClick={handleClose}
                  text="BACK"
                  className="doc-upload"
                ></Button>
              </div>
              ) : 
              <div className="d-flex justify-between feedBackFooterFix">
              <div>
                <Button
                  onClick={handleClose}
                  text="BACK"
                  className="modalButton3 doc-upload"
                ></Button>
              </div>
              <div>
                <Button
                  onClick={handleSubmit}
                  text="SUBMIT"
                  className="modalButton3 doc-uploadnext"
                ></Button>
              </div>
            </div>
            }
          
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    getPredefineOptions: state.AdminMentorReducer.getPredefineOptionsList.list,
  };
};

export default connect(mapStateToProps, {postEngagementNotes})(withRouter(EngagementNotesModal));
